"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- IMAGE UPLOADER : DEFINITION --------------- ++++++++++ */

var _default2 = {
  name: 'ImageUploader',
  props: {
    uploadImage: {
      type: 'function',
      default: function _default(blob) {
        return console.log(blob);
      }
    },
    discardFile: {
      type: 'function',
      default: function _default() {
        return console.log('Discard Clicked');
      }
    },
    maxWidth: {
      type: 'number',
      default: 5000,
      desc: 'Max width in pixels'
    },
    maxHeight: {
      type: 'number',
      default: 5000,
      desc: 'Max height in pixels'
    },
    maxSize: {
      type: 'number',
      default: 5000,
      desc: 'Max size in kb'
    },
    imageSrc: {
      type: 'string',
      default: null
    },
    fileName: {
      type: 'string',
      default: null
    },
    supportedFileTypes: {
      type: 'array',
      default: ['image/jpeg', 'image/png', 'image/gif']
    },
    uploading: {
      type: 'boolean',
      default: false
    }
  }
};
exports.default = _default2;